export function hslToHex(h: number, s: number, l: number) {
  l /= 100;
  const a = s * Math.min(l, 1 - l) / 100;
  const f = (n: number) => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color).toString(16).padStart(2, '0');   // convert to Hex and prefix "0" if needed
  };
  return `#${f(0)}${f(8)}${f(4)}`;
}
export function colorWithAlpha(color: string, alpha: number): string {

  if (alpha >= 1) return color;

  var r = 255, b = 0, g = 0;

  // Parse hsl/hsl() color
  if (color.startsWith("hsl")) {
    // Match hsl or hsla: hsl(120, 50%, 50%) or hsla(120, 50%, 50%, 1)
    const hslMatch = color.match(/hsla?\(\s*(\d+)[,\s]+(\d+)%[,\s]+(\d+)%/i);
    if (hslMatch) {
      const h = parseInt(hslMatch[1]);
      const s = parseInt(hslMatch[2]);
      const l = parseInt(hslMatch[3]);
      return `hsl(${h}, ${s}%, ${l}%, ${alpha})`;
    } else {
      console.warn("Unsupported HSL color format: " + color);
      return color;
    }
  } else if (color.startsWith("#")) {
    let hex = color.replace("#", "");
    if (hex.length === 3) hex = hex.split("").map(x => x + x).join("");
    if (hex.length === 6) {
      r = parseInt(hex.substring(0, 2), 16);
      g = parseInt(hex.substring(2, 4), 16);
      b = parseInt(hex.substring(4, 6), 16);
    }
  }
  // rgb/rgba
  else if (color.startsWith("rgb")) {
    const match = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    if (match) {
      r = parseInt(match[1]);
      g = parseInt(match[2]);
      b = parseInt(match[3]);
    }
  }
  else {
    console.warn("Unsupported color format: " + color);
  }

  return `rgba(${r},${g},${b},${alpha})`;

}
// Function to generate a color palette
export const generateColors = (count: number): string[] => {
  const colors: string[] = [];
  const goldenRatioConjugate = 0.618033988749895; // Golden ratio for better color distribution
  let hue = Math.random(); // Start with a random hue

  for (let i = 0; i < count; i++) {
    hue += goldenRatioConjugate;
    hue %= 1; // Keep hue in the range [0, 1]
    const h = Math.round(hue * 360); // Convert to degrees
    const s = 70; // Saturation
    const l = 50; // Lightness
    colors.push(`hsl(${h}, ${s}%, ${l}%)`);
  }

  return colors;
};